export var getTimeRemaining = function (dateTime, durationInMinutes) {
    if (dateTime === void 0) { dateTime = ""; }
    var startDateTime = new Date(dateTime);
    var endTime = (startDateTime === null || startDateTime === void 0 ? void 0 : startDateTime.getTime()) + durationInMinutes * 60 * 1000;
    var currentTime = Date.now();
    var result = +((endTime - currentTime) / 1000).toFixed(0);
    return result;
};
export var toMilliseconds = function (min, sec) { return (min * 60 + sec) * 1000; };
export var getRemainingMinutes = function (num) { return Math.floor(num % 60); };
export var getRemainingHours = function (num) { return Math.floor(num / 60); };
//# sourceMappingURL=timeUtils.js.map